module.exports = __webpack_public_path__ + "static/img/indexbg5.44e8645.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/indexbg5.jpg
// module id = KF1Q
// module chunks = 1